import { combineReducers } from "redux";
import modal from "./modal";

const rootReducers = combineReducers({ modal });

export type RootState = ReturnType<typeof rootReducers>;

export default rootReducers;
